import React from 'react';

import { MainEngineStarted } from 'screens/shared';

const GasMainEngineStarted = () => (
  <MainEngineStarted
    initialRpmValue="1500"
    iconLeft="icon-xm-bar-flask"
    iconRight="icon-xm-bar-fuel-sm"
    engineType="gas"
  />
);

export default GasMainEngineStarted;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasIdle/GasMainEngineStarted.js